import { defineStore } from "pinia";
import { readonly, ref } from "vue";
import { getUser } from "@/api/user";
import type { User } from "@/api/types.d";
import log from "@/utils/log";

export const useUserStore = defineStore("user", () => {
  const user = ref<User | null>(null);
  const isLoading = ref(false);
  const loaded = ref(false);
  const error = ref<string | null>(null);

  const fetchCurrentUser = async (force = false): Promise<void> => {
    if (isLoading.value) {
      return;
    }
    if (loaded.value && !force) {
      return;
    }

    isLoading.value = true;
    error.value = null;
    try {
      user.value = await getUser();
      loaded.value = true;
    } catch (err: unknown) {
      loaded.value = false;
      error.value = "ユーザー情報の取得に失敗しました";
      log(err instanceof Error ? err.message : "Unknown error");
    } finally {
      isLoading.value = false;
    }
  };

  return {
    user: readonly(user),
    isLoading: readonly(isLoading),
    loaded: readonly(loaded),
    error: readonly(error),
    fetchCurrentUser,
  };
});
